import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import React from 'react'
import { useContext } from '../Context'

import { LinkToPostItem } from '../../../../components/Links/LinkToPostItem'
import { Box, FullTableLoadingPlaceholder, Image, LoadingPlaceholder, ShowIf } from '@ztechapps/webui.util'
import { truncate } from '@ztechapps/common.utils'
import { Stack } from 'react-bootstrap'

export const RelatedPosts = () => {
  const { document, loading } = useContext()

  return (
    <LoadingPlaceholder loading={loading} as={FullTableLoadingPlaceholder}>
      <ShowIf condition={!isEmpty(document?.relatedPosts)}>
        <Box>
          <Box.Header>
            <div>
              <div className="fw-bold">Related posts</div>
              <small>Customers that bought this item also bought the following products</small>
            </div>
          </Box.Header>

          <Box.Body>
            <Stack>
              {map(document?.relatedPosts, (related) => (
                <div key={related?._id} className="border-top py-3 ">
                  <LinkToPostItem _id={related?._id}>
                    <Image
                      url={
                        related?.cover ??
                        'https://res.cloudinary.com/tmmshauler/image/upload/v1615587679/panelpunches/blog-cover.jpg'
                      }
                      name={related?.title}
                    />
                  </LinkToPostItem>
                  <div>
                    <div className="fw-bold">
                      <LinkToPostItem _id={related?._id}>{truncate(related?.title, 30)}</LinkToPostItem>
                    </div>
                    <small> {truncate(related?.summary, 150)}</small>
                  </div>
                </div>
              ))}
            </Stack>
          </Box.Body>
        </Box>
      </ShowIf>
    </LoadingPlaceholder>
  )
}
